/*
 * @Author: Hong.Zhang
 * @Date: 2021-11-02 11:08:08
 * @Description:
 */
export * from './components/Amount';
export * from './components/Email';
export * from './components/Input';
export * from './components/Phone';
export * from './components/DatePicker';
export * from './components/Select';
export * from './components/Button';
export * from './components/Upload';
export * from './components/TextArea';
export * from './components/Status';
export * from './components/Alert';
export * from './components/Preview';
export * from './components/Fold';
export * from './components/Dialog';
export * from './components/Checkbox';
export * from './components/RadioGroup';
export * from './components/Card';
export * from './components/Loading';
export * from './components/Step';
export { customTheme } from './theme';

import {
  requireNativeComponent,
  UIManager,
  Platform,
  ViewStyle,
} from 'react-native';

const LINKING_ERROR =
  `The package 'igloo-rn-widget' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are not using Expo managed workflow\n';

type IglooRnWidgetProps = {
  color: string;
  style: ViewStyle;
};

const ComponentName = 'IglooRnWidgetView';

export const IglooRnWidgetView =
  UIManager.getViewManagerConfig(ComponentName) != null
    ? requireNativeComponent<IglooRnWidgetProps>(ComponentName)
    : () => {
        throw new Error(LINKING_ERROR);
      };
